import AboutDepartment from "component/shared/about-department/AboutDepartment.jsx";

function MicrofilmAbout({ servicesTools }) {
  return (
    <div className="col-lg-4">
      <AboutDepartment
        id="about"
        txt={servicesTools?.about}
        translations={servicesTools?.serviceAndToolTranslation}
      />
    </div>
  );
}

export default MicrofilmAbout;
